import React from "react";
import styled from "styled-components";
import Tooltip from "../Generic/Tooltip";

const LanguagesTooltip = ({ languages, children }) => {
  if (!languages || languages.length === 0) {
    return children;
  }

  return (
    <Tooltip
      side="top"
      sideOffset={12}
      className="p-0 border-0 bg-transparent shadow-none [&_svg]:!hidden"
      content={
        <LanguagesTooltipContent>
          <LanguagesTooltipHeader>{languages.length} Languages</LanguagesTooltipHeader>
          <LanguagesTooltipChips>
            {languages.map((lang) => (
              <LanguageChip key={lang}>{lang}</LanguageChip>
            ))}
          </LanguagesTooltipChips>
        </LanguagesTooltipContent>
      }
    >
      {children}
    </Tooltip>
  );
};

export default LanguagesTooltip;

const LanguagesTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 320px;
  padding: 14px;
  border-radius: 12px;
  background: white;
  border: 1px solid #E9D7FE;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12), 0 2px 4px rgba(16, 24, 40, 0.06);
`;

const LanguagesTooltipHeader = styled.div`
  color: #6941C6;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const LanguagesTooltipChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 260px;
  overflow-y: auto;
  padding-right: 2px;
`;

const LanguageChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  background: #F4EBFF;
  border: 1px solid #E9D7FE;
  color: #6941C6;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;
